'use client';
import ShowPageWrapper from '@/components/ShowPageWrapper';

export default function Page() {
  return <ShowPageWrapper />;
}
